export function formatResolutionTime(TTRMinutes: number, short = false) {
  let text = `${TTRMinutes} min`;
  if (short) {
    // Convert minutes to total seconds
    const totalSeconds = Math.round(TTRMinutes * 60);
    
    // If less than 60 seconds, show as seconds
    if (totalSeconds < 60) {
      return `${totalSeconds}s`;
    }
    
    // If 60 seconds or more but less than 60 minutes, show as "Xm Ys"
    if (TTRMinutes < 60) {
      const minutes = Math.floor(TTRMinutes);
      const seconds = totalSeconds % 60;
      if (seconds > 0) {
        return `${minutes}m ${seconds}s`;
      }
      return `${minutes}m`;
    }
    
    // If 60 minutes or more, show as "Xh" or "Xh Ym"
    const hours = Math.floor(TTRMinutes / 60);
    const remainingMinutes = Math.floor(TTRMinutes % 60);
    if (remainingMinutes > 0) {
      return `${hours}h ${remainingMinutes}m`;
    }
    return `${hours}h`;
  }
  // Make it human readable for hours
  if (TTRMinutes > 60) {
    const hours = Math.floor(TTRMinutes / 60);
    text = `${hours} hour${hours > 1 ? 's' : ''} ${TTRMinutes % 60} min`;
  }
  // Make it human readable for days and overflow hours
  if (TTRMinutes > 1440) {
    const days = Math.floor(TTRMinutes / 1440);
    const hours = Math.floor((TTRMinutes % 1440) / 60);
    const minutes = TTRMinutes % 60;
    text = `${days} day${days > 1 ? 's' : ''} ${hours} hour${hours > 1 ? 's' : ''} ${minutes} min`;
  }

  return text;
}
